/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './sw-cms-el-preview-dvsn-form-builder.html.twig';
import './sw-cms-el-preview-dvsn-form-builder.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-dvsn-form-builder', {
    template
});
